import { render, staticRenderFns } from "./TransmittersViewTable.vue?vue&type=template&id=6dcadbe6&scoped=true&lang=pug"
import script from "./TransmittersViewTable.vue?vue&type=script&lang=js"
export * from "./TransmittersViewTable.vue?vue&type=script&lang=js"
import style0 from "./TransmittersViewTable.vue?vue&type=style&index=0&id=6dcadbe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcadbe6",
  null
  
)

export default component.exports